// global
import React from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'semantic-ui-react';

const ErrorLabel = ({ label, error, optional }) => {
    const trigger = (
        <label>
            {label} {optional === false ? '*' : ''}
        </label>
    );
    if (!error) {
        return trigger;
    }
    return <Popup trigger={trigger} content={error} flowing />;
};

ErrorLabel.defaultProps = {
    optional: false,
};

ErrorLabel.propTypes = {
    label: PropTypes.any.isRequired,
    error: PropTypes.string,
    optional: PropTypes.bool,
};

export default ErrorLabel;
